export default __webpack_public_path__ + "static/media/meditation_woman.f5ee2650.png";